export const GA_TRACKING_ID = process.env.NEXT_PUBLIC_GA_TRACKING_ID;
export const GTM_ID_UK_DEV = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_UK_DEV;
export const GTM_ID_EU_DEV = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_EU_DEV;
export const GTM_ID_UK_PROD = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_UK_PROD;
export const GTM_ID_EU_PROD = process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID_EU_PROD;

export function getGTMID(siteURL: string): string {
  switch (siteURL) {
    case 'https://www.americangolf.eu':
      console.log('Matched EU Production site', siteURL);
      return GTM_ID_EU_PROD || '';

    case 'https://www.americangolf.co.uk':
      console.log('Matched UK Production site', siteURL);
      return GTM_ID_UK_PROD || '';

    case 'https://dev-gb.americangolf.co.uk':
      console.log('Matched UK Development site', siteURL);
      return GTM_ID_UK_DEV || '';

    case 'https://dev-eu.americangolf.co.uk':
      console.log('Matched EU Development site', siteURL);
      return GTM_ID_EU_DEV || '';

    case 'https://staging.americangolf.co.uk':
      console.log('Matched UK Staging site', siteURL);
      return GTM_ID_UK_DEV || '';

    case 'https://staging.americangolf.eu':
      console.log('Matched EU Staging site', siteURL);
      return GTM_ID_EU_DEV || '';

    case 'https://qa.americangolf.co.uk':
      console.log('Matched UK QA site', siteURL);
      return GTM_ID_UK_DEV || '';

    case 'https://qa.americangolf.eu':
      console.log('Matched EU QA site', siteURL);
      return GTM_ID_EU_DEV || '';

    default:
      console.log('Default case matched (Fallback)', siteURL);
      return GTM_ID_UK_DEV || ''; // Fallback ID
  }
}
